/* eslint-env browser */
/* global $ */

import Isotope from 'isotope-layout';
import lazysizes from 'lazysizes'; // eslint-disable-line

const $referenceList = $('.reference-list');
const $referenceListItems = $referenceList.find('.reference-list__item');
const $referenceBanners = $referenceList.find('.banner');

let $matchingItems;
let gridAPI;

function init() {

	if (!$referenceBanners.length) {
		return;
	}

	// add simple support for background images:
	document.addEventListener('lazybeforeunveil', (evt) => {
		const bg = evt.target.getAttribute('data-bg');
		if (bg) {
			evt.target.style.backgroundImage = `url(${bg})`;
		}
	});

	$(document).on('filter-change.reference-list', filterItems);

	gridAPI = new Isotope($referenceList[0], {
		itemSelector: '.reference-list__item',
		layoutMode: 'fitRows',
		percentPosition: true
	});

}

function filterItems(e, filterParams) {

	$matchingItems = $referenceListItems.filter((index, el) => {
		const param = 'industry';

		const noParams = filterParams[param].length === 0;
		const showAll = filterParams[param].indexOf('-1') > -1;

		// Match the checkbox selections with the data-category of each reference
		// And display those references of wich data-category matches with checkbox values
		let isMatch = false;
		const splitString = $(el).data('category').split(',');
		const stringReference = filterParams[param].join(' ');
		splitString.forEach((item) => {
			if (stringReference.includes(item)) {
				isMatch = true;
			}
		})

		return noParams || showAll || isMatch;
	});

	$referenceListItems.removeClass('is-active');
	$matchingItems.addClass('is-active');

	gridAPI.arrange({ filter: '.is-active' });
}

export default {
	init
};
